var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0826 4.75155H15.4028L15.0586 3.49627C15.0342 3.40645 14.9725 3.33134 14.8895 3.28939C14.8065 3.24745 14.7094 3.2424 14.6229 3.27578L10.7024 4.78054C10.6613 4.76209 10.6161 4.75155 10.5682 4.75155H5.85615C5.76677 4.75155 5.68112 4.78801 5.61897 4.85235L2.71524 7.86363C2.65243 7.91304 2.61005 7.98244 2.59533 8.05952C2.59358 8.06743 2.59314 8.07578 2.59204 8.0839C2.59094 8.09444 2.58918 8.10454 2.58896 8.1153C2.58874 8.11948 2.58765 8.12365 2.58765 8.12782C2.58765 8.12804 2.58765 8.12826 2.58765 8.1287V18.4161C2.58765 18.5979 2.73501 18.7455 2.91707 18.7455H17.6129C17.7948 18.7455 17.9424 18.5979 17.9424 18.4161V17.2767H19.0824C19.2642 17.2767 19.4118 17.1292 19.4118 16.9473V5.08097C19.412 4.89891 19.2644 4.75155 19.0826 4.75155ZM15.5556 7.79951H4.67595L14.5195 4.02091L15.5556 7.79951ZM5.99605 5.41038H9.06163L4.19478 7.27859L5.99605 5.41038ZM17.2835 18.0867H3.24649V8.45833H17.2835V18.0867ZM18.7532 16.6179H17.9424V8.12892C17.9424 7.94686 17.7948 7.79951 17.6129 7.79951H16.2384L15.5833 5.41038H18.753L18.7532 16.6179Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinance);
export default __webpack_public_path__ + "static/media/iconFinance.a606949fbde5f4b11b459c8bf83ce53e.svg";
export { ForwardRef as ReactComponent };